<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
  export default {
    name: 'App',
    data() {

    },
    mounted() {
      
    }
  }
</script>

<style lang="less">
	@import "~@/assets/all.less";
</style>



// WEBPACK FOOTER //
// src/App.vue